<template>
  <KeepAlive>
    <component
      :is="currentComponent"
      :showModal="showModal"
      :goToStep="goToStep"
      :goBack="goBack"
      :cardList="cardList"
      @update:showModal="updateShowModal"
      @onRegisterPanstarPay="handleRegisterPanstarPay"
      @onDeleteCard="getPanstarPayCardList"
    />
  </KeepAlive>
</template>

<script>
import PanstarPayService from '@/services/neoHelios/cruise/panstarPay';

import PanstarPayModal from '@/components/panstarPay/PanstarPayModal.vue';
import PanstarPayRegister from '@/components/panstarPay/PanstarPayRegister.vue';
import PanstarPayRegisterComplete from '@/components/panstarPay/PanstarPayRegisterComplete.vue';

const FIRST_STEP = 'panstarPay';

export default {
  name: 'PanstarPayContainer',
  emits: ['onRegisterPanstarPay', 'onDeleteCard'],
  data() {
    return {
      currentStep: FIRST_STEP,
      cardList: [],
      showModal: false,
    };
  },
  computed: {
    currentComponent() {
      const componentMap = {
        panstarPay: PanstarPayModal,
        register: PanstarPayRegister,
        complete: PanstarPayRegisterComplete,
      };
      return componentMap[this.currentStep];
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(route) {
        const { query } = route;
        this.showModal = !!query.pay;
        this.goToStep(query.step);
      },
    },
    showModal: {
      immediate: true,
      handler(value, oldValue) {
        if (value) {
          this.init();
        } else {
          this.currentStep = FIRST_STEP;

          if (oldValue) {
            this.$router.push(this.$route.path);
          }
        }
      },
    },
  },
  methods: {
    updateShowModal(value) {
      this.showModal = value;
    },
    goToStep(step = FIRST_STEP) {
      if (!this.showModal) return;

      this.$router.push({ query: { ...this.$route.query, pay: true, step: step } });
      this.currentStep = step;
    },
    goBack() {
      this.$router.go(-1);
    },
    // 팬스타페이 카드 목록 조회 로직
    async getPanstarPayCardList() {
      try {
        const token = this.$route.query.token;
        const { data } = await PanstarPayService.getPanstarPayCardList(token);
        this.cardList = data || [];
      } catch (error) {
        this.$alert({ content: error });
      }
    },
    handleRegisterPanstarPay() {
      this.getPanstarPayCardList();
      this.$emit('onRegisterPanstarPay');
    },
    handleDeleteCard() {
      this.getPanstarPayCardList();
      this.$emit('onDeleteCard');
    },
    init() {
      this.getPanstarPayCardList();
    },
  },
};
</script>

<style scoped></style>
